<!-- ./src/pages/admin/Products.vue -->

<template src="./BoletosBB.html"></template>

<script>
  import usuario from "@/services/usuario";
  import juno from "@/services/juno";
  import moment from "moment";
  import { mapMutations } from "vuex";  
  import {json2excel, excel2json} from 'js2excel';

  export default {
    name: 'home',
    data () {
      return {
        
        menu: false,
        search: '',
        dialog: false,
        dialogError: false,
        dialogConfirmation: false,
        editando: false,
        user: null,
        items: [{_id: 'A', nome: 'A ser'}, {_id: 'B', nome: 'Baixados/Protestados/Liquidados'}],
        boletos:[],
        model: { status: 'B', date:new Date().toISOString().substr(0, 7) },
        headers: [{
            text: 'Registro',
            align: 'left',
            sortable: true,
            value: 'dataRegistro'
          },
          {
            text: 'Vencimento',
            align: 'left',
            sortable: true,
            value: 'dataVencimento'
          },{
            text: 'Movimento',
            align: 'left',
            sortable: true,
            value: 'dataMovimento'
          },{
            text: 'Nome',
            align: 'left',
            sortable: true,
            value: 'boleto.nomeSacadoCobranca'
          },
          // {
          //   text: 'Crédito',
          //   align: 'left',
          //   sortable: true,
          //   value: 'dataCredito'
          // },
          {
            text: 'Estado',
            align: 'left',
            sortable: true,
            value: 'estadoTituloCobranca'
          },
          {
            text: 'Numero',
            align: 'left',
            sortable: true,
            value: 'numeroBoletoBB'
          },
          {
            text: 'Valor Original',
            align: 'left',
            sortable: true,
            value: 'valorOriginal'
          },
          {
            text: 'Valor Atual',
            align: 'left',
            sortable: true,
            value: 'valorAtual'
          },
          {
            text: 'Valor Pago',
            align: 'left',
            sortable: true,
            value: 'valorPago'
          }
        ]
      }
    },
    async created () {
      this.buscar();
    },
    
    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
      computedDateFormatted2 () {
        return this.formatDate(this.date2)
      },
    },
    
    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
      date2 (val) {
        this.dateFormatted2 = this.formatDate(this.date2)
        this.model.data = this.date2;
      },
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      async buscar() {
        try {
          this.setLoading(true);
          let response = await juno.buscarBoletosBB(this.model);
          this.boletos = response.boletos;
          this.setLoading(false);
        } catch (e) {
          console.log(e);
          this.boletos = [];
          this.setLoading(false);
        }
      },
      exportarExcel (boletos) {
        let data = [];
        boletos.forEach(boleto => {
          let object = {
            "Registro": boleto.dataRegistro,
            "Vencimento": boleto.dataVencimento,
            "Movimento": boleto.dataMovimento,
            "Nome Devedor": boleto.boleto.nomeSacadoCobranca,
            "Estado": boleto.estadoTituloCobranca,
            "Numero": boleto.numeroBoletoBB,
            "Valor Original": boleto.valorOriginal,
            "Valor Atual": boleto.valorAtual,
            "Valor Pago": boleto.valorPago
          };
          data.push(object);
        });
        try {
            json2excel({
                data,
                name: 'boletosBB',
                formateDate: 'dd/mm/yyyy'
            });
        } catch (e) {
            console.error('export error');
        }
      },
      ...mapMutations({
        setLoading: "setLoading",
        setDevedor: "setDevedor",
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/boletosbb/BoletosBB.vue